(function () {
    'use strict';

    angular
        .module('SodCustomAction')
        .factory('ActionModel', ActionModel);

    function ActionModel(lodash) {
        var mem = {};

        return {
            set: set,
            sync: sync,
            destroy: destroy,
            // getAll: function() { return mem; },
            // clearAll: clearAll
        };

        function set(type, name, data) {
            lodash.set(mem, [type, name, 'model'].join('.'), data);
        }

        function sync(ref, type, name) {
            if (!lodash.has(mem, [type, name, 'model'].join('.'))) {
                lodash.set(mem, [type, name, 'model'].join('.'), {
                });
            }
            lodash.set(ref,'viewData', lodash.get(mem, [type, name].join('.'), {}));
        }

        function destroy(type, name) {
            if (lodash.has(mem, [type, name].join('.'))) {
                delete mem[type][name];
            }
        }

        // function clearAll() {
        //     mem = {};
        // }
    }
})();